export var CSS_DISABLE_CURSOR = _ref => {
  var {
    disabled,
    isDisabled
  } = _ref;
  return disabled || isDisabled ? 'cursor: not-allowed;' : null;
};
//# sourceMappingURL=cursor.js.map